import { Link } from "react-router-dom";
import { ClipboardDocumentCheckIcon } from "@heroicons/react/24/outline";
import {
  type EntityChecklistsProps,
  useEntityChecklistsSuspense
} from "@swivu/client-api";
import { ChecklistCard } from "@swivu/shared-ui";
import CommonStyles from "./CommonStyles.js";

type ChecklistProps = EntityChecklistsProps & {
  title: string;
  baseUrl?: string;
};

const EntityChecklists = (variables: ChecklistProps) => {
  const { data: checklists } = useEntityChecklistsSuspense(
    variables.entity_type
  )({
    variables
  });

  if (!checklists || checklists?.length === 0) return null;

  return (
    <CommonStyles
      badge={checklists.length}
      Icon={ClipboardDocumentCheckIcon}
      tone="checklists"
      title={`Checklists`}
      cardTitle={`${variables.title}`}
      cardSubtitle={`Checklists`}
      wrapperClassName="overflow-y-auto overflow-x-hidden"
    >
      <div className="flex w-full flex-col gap-4 pt-4">
        {checklists.map((checklist) => {
          const url =
            variables.baseUrl?.replace(":id", checklist.id.toString()) ||
            `/checklists/${checklist.id}`;
          return (
            <Link key={checklist.id} to={url} className="block">
              <ChecklistCard checklist={checklist} />
            </Link>
          );
        })}
      </div>
    </CommonStyles>
  );
};

export { EntityChecklists };
